import React from 'react';

import { ExecutionHistoryContext } from '@qality/common-components/src/lib/ExecutionHistoryProvider';
import { TestExecutionHistoryUtils } from '@qality/common-utils';

import { ReportedBugsView } from './ReportedBugs.view';

export const ReportedBugs: React.FC = () => {
  const { bugsReported } = React.useContext(ExecutionHistoryContext);

  const openExecution = (id: number) => {
    TestExecutionHistoryUtils.openTestExecutionInNewTab(id);
  };

  return (
    <ReportedBugsView
      isLoading={!bugsReported}
      openExecution={openExecution}
      bugs={bugsReported}
    />
  );
};
